import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TabComponent } from '../../../components/tab/tab.component';
import { APITableComponent } from '../../../components/table/api-table/api-table.component';
import { TabLayoutComponent } from '../../../components/tab-layout/tab-layout.component';
import { TableRow } from '../../../components/table/table.interface';

@Component({
  selector: 'app-manager-activities-tab',
  imports: [APITableComponent, TabLayoutComponent],
  templateUrl: './manager-activities-tab.component.html',
  providers: [
    { provide: TabComponent, useExisting: ManagerActivitiesTabComponent },
  ],
})
export class ManagerActivitiesTabComponent extends TabComponent {
  override name = this.dictionaryService.get('Managers Activities');

  constructor(private router: Router) {
    super();
  }

  public async main(): Promise<void> {}

  onRowClick = (row: TableRow) => {
    const userId = row.value['userId'];
    const userName = row.value['Name'];
    if (userId) {
      this.router.navigate(['/supervisors', userId], { state: { userName } });
    }
  };
}
